import { TicketClosureDTO, TicketDetailDTO } from '@/../client-generator/generated-clients/tickets';
import { Vue, Component, PropSync, Prop } from 'vue-property-decorator';
import { Loading } from 'element-ui';
import ticketClient from '@/core/api/tickets-service';

@Component
export default class AppTicketResolvedModal extends Vue {
  @PropSync('dialogIsVisible', { type: Boolean, required: true })
  dialogVisible!: boolean;

  @Prop({ required: true })
  readonly ticket!: TicketDetailDTO;

  loadingInstance: any = null;
  textarea = '';

  async resolveTicket() {
    try {
      if (!this.ticket) return;
      // Using service because v-loading directive doesn't work with dialogs
      this.loadingInstance = Loading.service({
        fullscreen: true,
      });

      const response = {
        ticketId: this.ticket.ticketId,
        solvedCorrectly: true,
        solveMessage: `L'utente ha segnalato il ticket come risolto: ${this.textarea}`,
      } as TicketClosureDTO;
      await ticketClient.close(response);
      this.backToList();
    } catch (error) {
      this.$message.error(error.toString());
    } finally {
      this.cancelTextarea();
      this.$nextTick(() => {
        if (this.loadingInstance != null) {
          this.loadingInstance.close();
        }
      });
    }
  }

  cancelTextarea() {
    this.textarea = '';
    this.dialogVisible = false;
  }

  backToList() {
    this.$router.push({
      name: 'page-tickets',
    });
  }

  dateToLocaleString(date) {
    return new Date(date).toLocaleString();
  }
}
